<div class="informative-loading-modal__container"
  [ngClass]="{'informative-loading-modal__container--basic': !timeoutExceed}">
  <!-- Contenedor -->
  <div class="common-modal__content-scroll">
    <div class="common-modal__content-header-feedback-info">
      @if (timeoutExceed) {
        <span [afTranslate]="'loader-modal.timeout-exceed-text'">_Estamos procesando un gran volumen de datos. Por favor, no cierres esta pantalla. Puedes seguir trabajando en una pestaña nueva.</span>
      }@else {
        <span [afTranslate]="'loader-modal.generate-'+typeText+'-primary'"></span>
        @if (!hideSecondaryText) {
          <span [afTranslate]="'loader-modal.generate-new-secondary'">_Por favor, no abandones la página.</span>
        }
      }
    </div>
  </div>
  <div class="informative-loading-modal__container-loader">
  <!-- <div class="common-spinner__block-spinner-description"> -->
    <p-progressSpinner styleClass="common-spinner__progress-container-color-LG"
      ariaLabel="loading"></p-progressSpinner>
    <!-- <span class="common-spinner__description-text-color">Descripción</span>
  </div> -->
  </div>

  <!-- Footer botonera -->
   @if (timeoutExceed) {
    <div class="common-modal__footer">
      <button class="common-button__text"
        (click)="openNewTab(itemSelected.url)">
        <span class="common-button__text-title" [afTranslate]="'loader-modal.open-new-tab'"></span>
      </button>
    </div>
  }
</div>
